document.querySelectorAll('.zimma-product__tabs').forEach((wrapper) => {
  const tabs = wrapper.querySelectorAll('[role="tab"]');
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach((other) => {
        other.setAttribute('aria-selected', other === tab ? 'true' : 'false');
        const panel = wrapper.querySelector(`#${other.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = other !== tab;
      });
    });
  });
});
